import _ from 'lodash';

export const isMacPlatform = () => {
  const userAgent = window.navigator.userAgent;
  return _.includes(_.toLower(userAgent), 'mac');
};

export const getKeyCombinationByPlatform = (event: KeyboardEvent) => {
  const isMac = isMacPlatform();
  return isMac ? event.metaKey : event.ctrlKey;
};
